// The order parts leave a card as it runs out of room. Nothing here is
// optional below its floor, and nothing later goes while something earlier
// stays — that monotonicity is the ladder.
export const DROP_ORDER = [
  'verdictLabels',
  'age',
  'facts',
  'duration',
  'actions',
  'links',
  'moreTags',
  'tags',
  'excerpt',
  'markers',
  'credit',
];

// The card size each part earns its place at, in px. Tuned by eye against
// today's cards; this is the one place to adjust how eagerly a card sheds.
const FLOORS = {
  // The words only — the bar stays. Pills plus ⋮ clearance outrank every other floor.
  verdictLabels: { width: 340, height: 245 },
  // The widest thing on the meta row and the least worth the space, the duration
  // behind it. useMetaFit sheds the same two in the same order.
  age: { width: 300, height: 240 },
  // The whole facts line, item count included: a small card is a picture and
  // a name. What the line holds above this floor is useFactsFit's call.
  facts: { width: 280, height: 224 },
  duration: { width: 270, height: 225 },
  // The menu catches an action; a dropped link has nowhere to go.
  actions: { width: 250, height: 215 },
  links: { width: 235, height: 200 },
  moreTags: { width: 225, height: 190 },
  tags: { width: 205, height: 185 },
  excerpt: { width: 190, height: 175 },
  markers: { width: 180, height: 165 },
  credit: { width: 150, height: 140 },
};

// Zen keeps what identifies the entity and takes its controls, at any size.
// `stats`, `menu`, `heatBadge` and `tagAdd` are controls that sit outside the
// ladder — they answer to zen alone.
const ZEN_HIDDEN = new Set([
  'actions',
  'markers',
  'age',
  'duration',
  // An entity card's facts beyond the two that identify it.
  'factDetails',
  'menu',
  'heatBadge',
  'tagAdd',
]);

/**
 * How far down DROP_ORDER a card of this size has fallen. A part that clears
 * its own floor still goes once a later one fails, so the order holds even
 * when the floors are mistuned.
 */
export function dropStep(width, height) {
  let step = 0;
  DROP_ORDER.forEach((part, index) => {
    const floor = FLOORS[part];
    if (width < floor.width || height < floor.height) step = index + 1;
  });
  return step;
}

/**
 * Whether a card at this step still shows the part. A part the ladder doesn't
 * name shows unless zen has taken it.
 */
export function cardShows(part, step, zenMode) {
  if (zenMode && ZEN_HIDDEN.has(part)) return false;
  const index = DROP_ORDER.indexOf(part);
  return index < 0 || index >= step;
}
